module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_BG-5023545e3e33a57d9ababa30d26489e7.svg";